import React from "react";
import DashLayout from "@/components/DashLayout";
import { Card } from "@/components/ui/card";
import { Rocket } from "lucide-react";

export default function Placeholder({ title, description, variant = "school" }) {
  return (
    <DashLayout variant={variant} title={title}>
      <Card className="p-10 text-center max-w-2xl mx-auto">
        <div className="w-16 h-16 rounded-full bg-blue-50 mx-auto flex items-center justify-center">
          <Rocket className="w-8 h-8 text-blue-700" />
        </div>
        <h2 className="text-xl font-bold mt-4">{title}</h2>
        <p className="text-slate-500 text-sm mt-2 max-w-md mx-auto">
          {description || "This module is scaffolded and backend endpoints are live. UI ships in the next sprint."}
        </p>
        <div className="text-xs text-slate-400 mt-6">Backend API: <code className="bg-slate-100 px-2 py-1 rounded">/api/erp/*</code></div>
      </Card>
    </DashLayout>
  );
}
